
import React from 'react';
import { css } from '@emotion/core';
import MoonLoader from 'react-spinners/MoonLoader';

const override = css`
	position: fixed;
	top: calc(50% - 30pt);
	left: calc(50% - 30pt);
	z-index: 100;
`;

const Loading = ({ loading }) => {
	return (
		<>
			{loading && <div className="full-screen" />}
			<MoonLoader css={override} size={60} color={'#fff'} loading={loading} />
		</>
	);
};

export default Loading;
